
import { useState } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import StateMap from './components/StateMap';
import StateDirectory from './components/StateDirectory';
import Footer from './components/Footer';

export default function AssessorDirectoryPage() {
  const [selectedState, setSelectedState] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  
  // TODO: Replace with actual user authentication check
  // For now, defaulting to false (free user)
  const isPremiumUser = false;

  const handleStateSelect = (state: string) => {
    setSelectedState(state);
  };

  const handleSearch = (query: string) => {
    setSearchQuery(query);
  };

  return (
    <div className="min-h-screen bg-slate-900">
      <Header />
      <HeroSection onSearch={handleSearch} isPremiumUser={isPremiumUser} />
      <StateMap onStateSelect={handleStateSelect} />
      <StateDirectory 
        selectedState={selectedState} 
        searchQuery={searchQuery}
        isPremiumUser={isPremiumUser}
      />
      <Footer />
    </div>
  );
}
